import { useLocation, useNavigate } from 'react-router';
import FERPA from '../../../../../components/FERPA/FerpaComponent';
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons';
import '../styles/idCards.scss';
import logoUrl from '../../../../../assets/images/CastleLearningLogo.png';
import html2pdf from 'html2pdf.js';
import ProgressButton from '../../../../../components/ProgressButton';

const IdCards = () => {
  const navigate = useNavigate();
  const [numberCardsPerPage, setNumberCardsPerPage] = useState(4);
  const location = useLocation();
  const students = location.state?.students;
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);

  const handlePrintPdf = async () => {
    if(isPdfGenerating) return;

    setIsPdfGenerating(true);
    const contentWrapper = document.getElementById('studentIdCards');
    const contentClone = contentWrapper.cloneNode(true);
    const newContentWrapper = document.createElement('div');
    newContentWrapper.style.display = 'flex';
    newContentWrapper.style.flexDirection = 'column';
    newContentWrapper.style.gap = '16px';

    const cards = Array.from(contentClone.querySelectorAll('.id-card'));
    for (let i = 0; i < cards.length; i += numberCardsPerPage) {
      const chunk = cards.slice(i, i + numberCardsPerPage);
  
      const page = document.createElement('div');
      if(i + numberCardsPerPage < cards.length)
        page.style.pageBreakAfter = 'always';
  
      for (let j = 0; j < chunk.length; j += 2) {
        const row = document.createElement('div');
        row.style.display = 'flex';
        row.style.gap = '16px';
        row.style.marginBottom = '16px';
        const rowCards = chunk.slice(j, j + 2);
        rowCards.forEach(card => row.appendChild(card));
  
        page.appendChild(row);
      }
      newContentWrapper.appendChild(page);
    }
  
    const options = {
      margin: 40,
      filename: 'StudentIdCards.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'landscape' }
    };

    await html2pdf().set(options).from(newContentWrapper).save();
    setIsPdfGenerating(false);
  };

  const horizontalLine = '\u2015'.repeat(20); 

  return (
    <div className="white-card">
      <div>
        <Row className='m-2'>
          <Col>
            <span className='primary-title fw-medium'>Print ID Cards</span>
          </Col>
          <Col className='align-items-center col d-flex gap-3 justify-content-end'>
            <FERPA hideCheckBox={true} />
            <button
              onClick={() => navigate(-1)}
              className="btn btn-castleWhite btn-width">
              Back
            </button>
            <ProgressButton
              isLoading={isPdfGenerating}
              onClick={handlePrintPdf}
              loadingLabel="Generating PDF"
              label="Print to PDF"
              className="btn btn-castleRed"
              expectedDuration={1500}
            />
          </Col>
        </Row>
        {students?.length>4 && <Row className='m-2'>
          <Col className='d-flex align-items-center'>
            <div className='mr-2'>Please input the number of cards desired per page</div>
            <div className='d-flex bg-castleGray rounded-3'>
              <button className='btn grid-icon-btn btn-light mx-2 m-2' onClick={() => setNumberCardsPerPage(numberCardsPerPage == 4 ? numberCardsPerPage : numberCardsPerPage - 2)}>
                <FontAwesomeIcon icon={faMinus} />
              </button>
              <div className='p-3'>{numberCardsPerPage}</div>
              <button className='btn grid-icon-btn btn-light mx-2 m-2' onClick={() => setNumberCardsPerPage(numberCardsPerPage == 8 ? numberCardsPerPage : numberCardsPerPage + 2)}>
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </div>
          </Col>
        </Row>
        }
        <Row className='mt-4' id='studentIdCards'>
          <Col>
            <Row>
              {students?.map((student) => (
                <Col key={student.studentId} className='col-md-5 m-3'>
                  <div className="id-card">
                    <div className="id-card-header">
                      Castle Learning
                    </div>
                    <div className="id-card-body">
                      <div className="id-card-details">
                        <div className="id-card-detail"><span>Website</span>:&nbsp;&nbsp; castlelearning.com</div>
                        <div className="id-card-detail"><span>Name</span>:&nbsp;&nbsp; {student.lName} &nbsp; {student.fName}</div>
                        <div className="id-card-detail"><span>Login ID</span>:&nbsp;&nbsp; {student.login}</div>
                        <div className="id-card-detail continuous-line"><span>Password</span>:&nbsp;&nbsp;{horizontalLine} </div>
                      </div>
                      <div className="align-content-center id-card-image">
                        <img src={logoUrl} alt="Castle Learning Logo" />
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default IdCards;